<vi-loader
  data-at-loader
  *ngIf="featuresLoading$ | async"
  [isLoading]="true"
  [message]="'+USER_REGISTRATION.USER_REGISTRATION.LOADING_MESSAGES.DATA' | translate"
></vi-loader>

<!-- low battery info -->
<ng-container *ngIf="battery$ | async | ready as battery">
  <ng-container
    *ngIf="
      battery.properties?.level?.value !== null &&
      battery.properties?.level?.value < lowBatteryThreshold
    "
  >
    <div class="low-battery-wrapper">
      <vi-icon name="battery-low-src" [size]="16"></vi-icon>
      <span> {{ '+INSTALLATIONS.SRC.LOW_BATTERY' | translate }} </span>
    </div>
  </ng-container>
</ng-container>

<!-- device name -->
<ng-container *ngIf="deviceName$ | async | ready as deviceName">
  <app-feature-list-item
    data-at-device-name
    [label]="'+INSTALLATIONS.SRC.DEVICE.DESCRIPTION' | translate"
    [editable]="true"
    [value]="deviceName | value2: featurePropertyKey.name"
    (edit)="openEditDeviceNameDialog(deviceId)"
  >
  </app-feature-list-item>
</ng-container>

<!-- id -->
<app-feature-list-item
  data-at-id
  [label]="'+INSTALLATIONS.SRC.DEVICE.ID' | translate"
  [value]="deviceId | idPrefixRemover | serialSpacing"
>
</app-feature-list-item>

<!-- device error info message -->
<ng-container *ngIf="deviceErrors$ | async as deviceErrors">
  <app-feature-list-item
    data-ut-error
    *ngFor="let error of deviceErrors"
    [label]="error?.errorCode"
    [description]="error?.errorDescription"
    [value]="error?.appearedAt | date: 'short'"
    [error]="true"
  >
  </app-feature-list-item>
</ng-container>

<!-- Device disconnected alert -->
<ng-container *ngIf="status$ | async | ready as status">
  <!-- Device disconnected alert -->
  <app-feature-list-item
    *ngIf="installationService.isSrcDeviceNotConnected(status)"
    [isNgContent]="true"
  >
    <app-banner>
      {{ '+INSTALLATIONS.SRC.ETRV.DISCONNECTED' | translate : { time: status.timestamp |
      dateForSpecificTimezone: (installationTimezone$ | async) | date: 'short' } }}
    </app-banner>
  </app-feature-list-item>

  <!-- wifi lqi -->
  <app-feature-list-item
    data-at-air-quality-sensor-wifi-lqi
    *ngIf="wifiLqi$ | async | ready as feature"
    [error]="feature | error"
    [label]="'+INSTALLATIONS.SRC.ETRV.WIFI_LQI_STRENGTH.TITLE' | translate"
    [isNgContent]="true"
    timestamp="{{ feature?.timestamp | date: 'short' }}"
    [attr.data-feature]="feature.feature + '/strength'"
  >
    <ng-container
      *ngIf="
        feature.properties?.strength && feature.properties?.strength?.value < lowLqiSignalThreshold;
        then lowSignal;
        else stableSignal
      "
    ></ng-container>

    <ng-template #lowSignal>
      <span class="warning-box">
        <mat-icon>error</mat-icon>
        {{ installationService.isSrcDeviceNotConnected(status) ? noValue : (feature | value2:
        featurePropertyKey.strength) + ' ' + (feature | unit: 'strength') }}</span
      >
    </ng-template>

    <ng-template #stableSignal>
      {{ installationService.isSrcDeviceNotConnected(status) ? noValue : (feature | value2:
      featurePropertyKey.strength) + ' ' + (feature | unit: 'strength') }}
    </ng-template>
  </app-feature-list-item>

  <!-- device.power.battery -->
  <app-feature-list-item
    data-at-battery
    *ngIf="battery$ | async | ready as feature"
    [error]="feature | error"
    [label]="'+INSTALLATIONS.SRC.ETRV.BATTERY_STATUS' | translate"
    value="{{
      installationService.isSrcDeviceNotConnected(status)
        ? noValue
        : (feature | value2: featurePropertyKey.level) + ' ' + (feature | unit: 'level')
    }}"
    [attr.data-feature]="feature.feature"
    timestamp="{{ feature.timestamp | date: 'short' }}"
  >
  </app-feature-list-item>

  <!-- co2 sensor actual PPM -->
  <app-feature-list-item
    *ngIf="sensorCo2$ | async | ready as feature"
    [error]="feature | error"
    [label]="'+INSTALLATIONS.SRC.AIR_QUALITY_SENSOR.ACTUAL_PPM' | translate"
    value="{{ feature | value2: featurePropertyKey.value }} {{ feature | unit: 'value' }}"
    [attr.data-feature]="feature.feature"
    timestamp="{{ feature.timestamp | date: 'short' }}"
  >
  </app-feature-list-item>

  <!-- device.sensors.temperature -->
  <app-feature-list-item
    *ngIf="temperature$ | async | ready as feature"
    [error]="feature | error"
    [label]="'+INSTALLATIONS.SRC.ETRV.CURRENT_TEMPERATURE' | translate"
    value="{{
      installationService.isSrcDeviceNotConnected(status)
        ? noValue
        : (feature | value2: featurePropertyKey.value) + ' ' + (feature | unit: 'value')
    }}"
    [attr.data-feature]="feature.feature"
    timestamp="{{ feature.timestamp | date: 'short' }}"
  >
  </app-feature-list-item>

  <!-- device.sensors.humidity -->
  <app-feature-list-item
    *ngIf="humidity$ | async | ready as feature"
    [error]="feature | error"
    [label]="'+INSTALLATIONS.SRC.CS.HUMIDITY' | translate"
    value="{{
      installationService.isSrcDeviceNotConnected(status)
        ? noValue
        : (feature | value2: featurePropertyKey.value) + ' ' + (feature | unit: 'value')
    }}"
    [attr.data-feature]="feature.feature"
    timestamp="{{ feature.timestamp | date: 'short' }}"
  >
  </app-feature-list-item>

  <!-- device.sensors.firmware-->
  <app-feature-list-item
    data-at-cs-sensor-firmware
    *ngIf="firmware$ | async | ready as feature"
    [error]="feature | error"
    [label]="'+INSTALLATIONS.SRC.FIRMWARE' | translate"
    value="
      {{feature | value2: featurePropertyKey.value}}
    "
    [attr.data-feature]="feature.feature"
    timestamp="{{ feature.timestamp | date: 'short' }}"
  >
  </app-feature-list-item>
</ng-container>
